import { render, staticRenderFns } from "./PurchasingSelectModal.vue?vue&type=template&id=6e408a04&"
import script from "./PurchasingSelectModal.vue?vue&type=script&lang=js&"
export * from "./PurchasingSelectModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports